// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.simple-floatingedges {
  flex-direction: column;
  display: flex;
  flex-grow: 1;
  /* height: 100%; */
}

.simple-floatingedges .react-flow__handle {
  width: 10px;
  height: 10px;
  background-color: #ccc;
}

.simple-floatingedges .react-flow__handle-top {
  top: -17px;
}

.simple-floatingedges .react-flow__handle-bottom {
  bottom: -17px;
}

.simple-floatingedges .react-flow__handle-left {
  left: -17px;
}

.simple-floatingedges .react-flow__handle-right {
  right: -17px;
}

.simple-floatingedges .react-flow__node-custom {
  background: #fff;
  border: 1px solid #1a192b;
  border-radius: 3px;
  color: #222;
  font-size: 12px;
  padding: 10px;
  text-align: center;
  width: 150px;
}

.react-flow__edge-selector {
  pointer-events: all;
}

.edgebutton {
  width: 20px;
  height: 20px;
  background: #ffffff;
  border: 1px solid #555;
  cursor: pointer;
  border-radius: 50%;
  font-size: 12px;
  line-height: 1;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 6px 2px rgba(0, 0, 0, 0.08);
  transition: box-shadow 0.2s ease-in-out, background-color 0.2s ease-in-out;
}

.edgebutton:hover {
  box-shadow: 0 0 6px 2px rgba(0, 0, 0, 0.15);
  background-color: #f0f0f0;
}`, "",{"version":3,"sources":["webpack://./src/components/flow/simple-floatingedges.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C;EAC3C,0EAA0E;AAC5E;;AAEA;EACE,2CAA2C;EAC3C,yBAAyB;AAC3B","sourcesContent":[".simple-floatingedges {\n  flex-direction: column;\n  display: flex;\n  flex-grow: 1;\n  /* height: 100%; */\n}\n\n.simple-floatingedges .react-flow__handle {\n  width: 10px;\n  height: 10px;\n  background-color: #ccc;\n}\n\n.simple-floatingedges .react-flow__handle-top {\n  top: -17px;\n}\n\n.simple-floatingedges .react-flow__handle-bottom {\n  bottom: -17px;\n}\n\n.simple-floatingedges .react-flow__handle-left {\n  left: -17px;\n}\n\n.simple-floatingedges .react-flow__handle-right {\n  right: -17px;\n}\n\n.simple-floatingedges .react-flow__node-custom {\n  background: #fff;\n  border: 1px solid #1a192b;\n  border-radius: 3px;\n  color: #222;\n  font-size: 12px;\n  padding: 10px;\n  text-align: center;\n  width: 150px;\n}\n\n.react-flow__edge-selector {\n  pointer-events: all;\n}\n\n.edgebutton {\n  width: 20px;\n  height: 20px;\n  background: #ffffff;\n  border: 1px solid #555;\n  cursor: pointer;\n  border-radius: 50%;\n  font-size: 12px;\n  line-height: 1;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 0 6px 2px rgba(0, 0, 0, 0.08);\n  transition: box-shadow 0.2s ease-in-out, background-color 0.2s ease-in-out;\n}\n\n.edgebutton:hover {\n  box-shadow: 0 0 6px 2px rgba(0, 0, 0, 0.15);\n  background-color: #f0f0f0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
